import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, DollarSign, Ship } from 'lucide-react';
export function RecentShipments() {
  const shipments = [{
    boat: "32' Sea Ray",
    route: 'Miami, FL → Lake Tahoe, NV',
    price: '$2,450',
    img: 'https://images.unsplash.com/photo-1564346128522-861502472948?q=80&w=600&auto=format&fit=crop'
  }, {
    boat: "28' Pontoon",
    route: 'Dallas, TX → Lake Havasu, AZ',
    price: '$1,380',
    img: 'https://images.unsplash.com/photo-1583480076231-15b50d536097?q=80&w=600&auto=format&fit=crop'
  }, {
    boat: "40' Yacht",
    route: 'Fort Lauderdale, FL → San Diego, CA',
    price: '$4,900',
    img: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?q=80&w=600&auto=format&fit=crop'
  }, {
    boat: "22' Bass Boat",
    route: 'Atlanta, GA → Orlando, FL',
    price: '$690',
    img: 'https://images.unsplash.com/photo-1560023907-5f339617ea30?q=80&w=600&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-249">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-250">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-251">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-252">
            Recent Boat Shipments
          </h2>
          <p className="text-lg text-slate-600" data-id="element-253">
            Real examples of our nationwide boat transport services. We provide
            transparent, competitive boat hauling quotes for vessels of all
            sizes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-254">
          {shipments.map((shipment, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="bg-white rounded-xl overflow-hidden shadow-md border border-slate-100 hover:shadow-xl transition-shadow" data-id="element-255">
              <div className="h-40 overflow-hidden" data-id="element-256">
                <img src={shipment.img} alt={`${shipment.boat} transport`} className="w-full h-full object-cover" data-id="element-257" />
              </div>
              <div className="p-5 space-y-3" data-id="element-258">
                <div className="flex items-center gap-2 text-brand-navy font-bold text-lg" data-id="element-259">
                  <Ship className="w-5 h-5 text-brand-red" data-id="element-260" />
                  {shipment.boat}
                </div>
                <div className="flex items-start gap-2 text-sm text-slate-600" data-id="element-261">
                  <MapPin className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" data-id="element-262" />
                  <span data-id="element-263">{shipment.route}</span>
                </div>
                <div className="flex items-center gap-2 text-brand-navy font-black text-xl pt-2 border-t border-slate-100" data-id="element-264">
                  <DollarSign className="w-5 h-5 text-green-600" data-id="element-265" />
                  {shipment.price}
                </div>
              </div>
            </motion.div>)}
        </div>
        <p className="text-xs text-slate-400 text-center mt-8" data-id="element-266">
          * Prices shown are real-world examples. Actual boat shipping costs
          vary based on exact dimensions, route, season, and current fuel
          prices.
        </p>
      </div>
    </section>;
}